// Safe helpers that always add thousands separators (3,300 not 3300)

const NF_INT   = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 });
const NF_NUM   = new Intl.NumberFormat('en-GB', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
const NF_GBP   = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2 });

const isNum = (v) => typeof v === 'number' && Number.isFinite(v);

/** 3,300 (no decimals) */
export function fmtInt(v, fallback = '—') {
  const n = Number(v);
  return Number.isFinite(n) ? NF_INT.format(n) : fallback;
}

/** 3,300.45 (0–2 decimals) */
export function fmtNum(v, fallback = '—') {
  const n = Number(v);
  return Number.isFinite(n) ? NF_NUM.format(n) : fallback;
}

/** £3,300.45 */
export function fmtGBP(v, fallback = '£0.00') {
  const n = Number(v);
  return Number.isFinite(n) ? NF_GBP.format(n) : fallback;
}

/** "2026-10-14" or an ISO timestamp -> "14/10/2026". Anything else is returned as-is. */
export function fmtDay(v, fallback = '—') {
  if (!v) return fallback;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(v));
  return m ? `${m[3]}/${m[2]}/${m[1]}` : String(v);
}
